// extracted by mini-css-extract-plugin
export default {"errorBoundary":"ErrorBoundary_errorBoundary__Ljgsg","container":"ErrorBoundary_container__2SgD1","heading":"ErrorBoundary_heading__ypB14","button":"ErrorBoundary_button__7ciCj"};